module.exports = __webpack_public_path__ + "media/images/folder-icon-2ec7da83741e6c65799d1d6aff2c0322.svg";